import type { HttpInterceptorFn } from '@angular/common/http';
import { LocationService } from './location-required.service';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';

export const locationInterceptor: HttpInterceptorFn = (req, next) => {
  
  let _LocationService: LocationService = inject(LocationService);
  if (!(req.url.includes('shouldEncrypt') || _LocationService.coords())) {
    return EMPTY
  } else {
    return next(req);
  }
};
